export const throttle = (callback, current, dist) => {
  let lastValue = 0;

  if (current - lastValue >= dist) {
    lastValue = current;
    callback();
  }
};

export default throttle;
